<template>
  <div id="widget">
    <div
      v-if="loadingStatus"
      class="flex flex-col items-center justify-center min-h-screen w-full"
    >
      <div
        class="spinner mx-auto"
        style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
      ></div>
      <div class="p-4" style="color: rgb(78 143 243);">
        Loading, please wait...
      </div>
    </div>

    <div v-else id="page" class="min-h-screen flex flex-col w-full">
      <div
        id="survey-panel"
        class="w-full px-4 md:px-10 flex flex-col pt-8 pb-10 flex-grow"
        :style="{ 'background-color': bgColor }"
      >
        <div id="center-panel" class="flex-grow flex flex-col justify-center">
          <div
            v-if="step.type == 'image'"
            id="options-display"
            class="relative mx-auto w-full"
            :key="step.id"
          >
            <transition appear name="slide" tag="div" id="step_slide">
              <div :key="step.id">
                <div class="mx-auto font-bold text-center">
                  <div
                    v-text="title"
                    class=" text-xl block mx-auto px-5 text-center "
                    :style="{
                      color: fontColor,
                      'font-family': survey.fontFamily,
                    }"
                  ></div>
                </div>
                <div class="mx-auto text-center mt-1">
                  <div
                    v-text="subtitle"
                    class="block mx-auto px-5  text-center"
                    :style="{
                      color: fontColor,
                      'font-family': survey.fontFamily,
                    }"
                  ></div>
                </div>

                <div
                  class="flex flex-wrap justify-center mx-auto mt-2"
                  :key="step.id"
                  id="option_list"
                  :style="{ 'max-width': containerWidth }"
                >
                  <option-display
                    :key="option.id"
                    v-for="option in options"
                    :option="option"
                    :survey="survey"
                    :step="step"
                    v-on:click="clickHandler"
                    :selected="option.selected"
                  ></option-display>
                </div>

                <SurveyButton
                  :survey="survey"
                  :step="step"
                  @click="gotoNext"
                  class="mt-5 mb-2"
                />
              </div>
            </transition>
          </div>

          <WelcomeStep
            v-if="step.type == 'welcome'"
            :survey="survey"
            :step="step"
            :key="step.id"
            @goto-next="gotoNext"
          />
          <CloseStep
            v-if="step.type == 'end'"
            :survey="survey"
            :step="step"
            :key="step.id"
            @close-widget="$emit('close-widget')"
          />
        </div>
      </div>
      <!--End Survey Panel -->

      <div id="footer-spacer" class="h-8 sm:h-0"></div>
      <div
        class="fixed bottom-0 right-0 w-full sm:w-max sm:bottom-5 sm:right-5 h-8 sm:h-auto text-center cursor-pointer text-xs border border-solid border-gray-200 px-2 py-2 sm:rounded shadow hover:shadow-lg"
        :style="{
          color: survey.buttons[0].fontColor,
          'font-family': survey.fontFamily,
          'background-color': survey.buttons[0].bgColor,
          'border-color': survey.buttons[0].borderColor,
        }"
      >
        Made with <strong>AppFlowz</strong>
      </div>
    </div>
    <!-- End page -->
  </div>
</template>

<script>
//import { FontFamily } from "@/mixins/FontFamily.js";
import OptionDisplay from "@/components/Survey/OptionDisplay.vue";
import Survey from "@/models/Survey";
import Option from "@/models/Option";
import Response from "@/models/Response";
import Visitor from "@/models/Visitor";
import SurveyButton from "@/components/Survey/SurveyButton";

import router from "@/router/route.js";
import CloseStep from "@/components/Survey/CloseStep.vue";
import WelcomeStep from "@/components/Survey/WelcomeStep.vue";
//import router from "@/router/widget-router.js";

export default {
  name: "widget-main",
  //mixins: [FontFamily],
  components: {
    OptionDisplay,
    SurveyButton,
    CloseStep,
    WelcomeStep,
  },
  props: ["surveyid", "stepid", "pixelData"],
  data() {
    return {
      loadingStatus: true,
      //stepId: null,
      stepIndex: null,
    };
  },
  created() {
    console.log("created hook");
    this.init();
  },
  watch: {
    $route(to, from) {
      this.stepIndex = this.findIndex(this.stepId);
      //this.init();
    },
  },
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("buttons")
        .with("steps", (query) => {
          query.orderBy("order", "asc").with("options", (query) => {
            query.orderBy("order", "asc");
          });
        })
        .first();
    },
    steps() {
      return this.survey.steps;
    },
    step() {
      return this.stepIndex > -1 ? this.survey.steps[this.stepIndex] : null;
    },
    stepId() {
      //return: a) prop || b) route param || c) first step in survey
      return this.stepid || this.steps[0]["id"] || null;
    },
    options() {
      return this.step.options;
    },
    visitorData() {
      return {
        user_id: this.survey.user_id || null,
        email: this.pixelData.email || null,
        customer_id: this.pixelData.user_id || null,
        name: this.pixelData.name || null,
      };
    },
    visitor() {
      return Visitor.query()
        .where("email", this.visitorData.email)
        .where("user_id", this.visitorData.user_id)
        .first();
    },

    //STYLE PROPERTIES
    font() {
      return this.survey.font;
    },
    fontColor() {
      return this.survey.fontColor;
    },
    bgColor() {
      return this.survey.bgColor;
    },
    containerWidth() {
      return this.step.containerWidth();
    },

    //CONTENT
    title() {
      return this.step.title;
    },
    subtitle() {
      return this.step.subtitle;
    },
  },
  methods: {
    async init() {
      console.log("init called");
      this.loadingStatus = true;
      var id = this.surveyid || null;

      if (id === null) {
        console.log("Error: survey id missing.");
        this.loadingStatus = false;
        this.$destroy();
      }

      //if survey is not already loaded in state, request it from the server
      if (this.survey === null) {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
        console.log("requesting survey from server");
      }

      //if visitor is not already loaded in state, try to load it from server
      if (this.visitor === null) {
        console.log("attempting to load visitor from server");
        await Visitor.api().get(
          "/api/visitor/" +
            this.visitorData.email +
            "/user/" +
            this.survey.user_id,
          {
            dataKey: "data",
          }
        );

        //if still null, create new visitor and save to server
        if (this.visitor === null) {
          console.log("no visitor found on server, creating new visitor");
          await Visitor.create({ data: this.visitorData });

          try {
            console.log("saving new visitor to backend database");
            var post = await Visitor.api().post(
              "/api/visitor/save",
              this.visitor
            );
          } catch (err) {
            //Log error
          }

          if (post.response.status == 200) {
            //success
          } else {
            //error
          }
        }
      }

      if (this.survey != null && this.visitor != null) {
        this.loadResponses();
      }

      this.stepIndex = this.findIndex(this.stepId);

      this.loadingStatus = false;
    },
    async loadResponses() {
      //Load previous responses, if any, from server into Vuex-ORM
      await Response.api().get(
        `/api/response/survey/${this.survey.id}/visitor/${this.visitor.id}`,
        { dataKey: "data" }
      );

      //get all responses
      var responses = Response.query()
        .where("survey_id", this.survey.id)
        .get();

      responses.forEach((response) => {
        this.steps.forEach((step) => {
          step.options.forEach((option) => {
            let option_value = option.value || option.title;

            if (response.value == option_value) {
              console.log("true: " + response.value);
              Option.update({ where: option.id, data: { selected: true } });
            }
          });
        });
      });
    },

    findIndex(step_id) {
      return this.steps.findIndex((step) => step.id === step_id) || 0;
    },
    gotoNext() {
      //increment step
      var nextIndex = this.stepIndex + 1;

      if (nextIndex < this.steps.length) {
        var nextStep = this.steps[nextIndex];

        console.log("going to step: " + nextStep.id);

        //navigate to next step and add to browser history
        router.push({
          name: "show",
          params: { id: nextStep.id },
        });
      } else {
        router.push({
          name: "show",
          params: { id: "end" },
        });
      }
    },
    closeWidget() {
      this.$emit("close-widget");
      this.$destroy();
    },

    //Stores the answer choice selected by the user as a Response model
    //option = the answer choice selected by the user
    async saveSelected(option) {
      //update option selected state to true (triggers 'selected' UI)
      Option.update({ where: option.id, data: { selected: true } });

      //save Response model to Vuex-ORM state
      var response = await Response.insertNew({
        data: {
          visitor_id: this.visitor.id,
          step_id: this.step.id,
          survey_id: this.survey.id,

          //Save custom value if any, else save option.title
          value: option.value || option.title,
        },
      });

      //save response to server
      await Response.api().post("/api/response/save", response);
    },

    //Removes a previously selected answer choice
    async removeSelected(option) {
      //Update option selected state to false (removes 'selected' UI)
      Option.update({ where: option.id, data: { selected: false } });

      var response = Response.query()
        .where("visitor_id", this.visitor.id)
        .where("step_id", this.step.id)
        .where("value", option.title)
        .first();

      //Delete response from server
      await Response.api().delete("/api/response/delete/" + response.id);

      response.$delete();
    },

    //Removes all previous responses for a given step/question
    removeAll(step) {
      //Delete Response models for current step
      Response.delete((response) => {
        return (
          response.visitor_id == this.visitor.id &&
          response.step_id == this.step.id
        );
      });

      //Reset all option selected states to false (triggers UI change)
      step.options.forEach((option) => {
        Option.update({ where: option.id, data: { selected: false } });
      });
    },
    async clickHandler(option) {
      if (this.step.allow_many) {
        //This looks a little wonky, but it simply toggles the selected state of the Option model
        //between true/false, which trigges the 'selected' UI changes in SurveyOptionDisplay
        let updated = await Option.update({
          where: option.id,
          data: { selected: !option.selected },
        });

        if (updated.selected) {
          this.saveSelected(option);
        } else {
          this.removeSelected(option);
        }
      } else {
        //Delete any previous responses for the current step
        this.removeAll(this.step);

        //Save the current selection
        this.saveSelected(option);

        this.forward(option);
      }
    },
    forward(option) {
      //if link to external site, then go there
      if (option.goto == "link" && option.goto_link != "")
        window.location.href = option.goto_link;
      //next step or default, go to next
      else if (option.goto == "next") {
        this.gotoNext();
      }

      //option linked to a specified step
      else {
        router.push({
          name: "show",
          params: { id: option.goto },
        });
      }
    },
  },
};
</script>

<style>
#widget {
  overflow-x: hidden;
  min-height: calc(100vh - 56px);
}
.slide-leave-active {
  transition: 0.01s;
}
.slide-enter-active {
  transition: 0.8s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
.panel-sm,
.panel-md,
.panel-lg {
  width: 250px;
}
@media (min-width: 640px) {
  .panel-sm {
    width: 250px;
  }
  .panel-md {
    width: 300px;
  }
  .panel-lg {
    width: 330px;
  }
}
@media (min-width: 1024px) {
  .panel-sm {
    width: 250px;
  }
  .panel-md {
    width: 330px;
  }
  .panel-lg {
    width: 400px;
  }
}
</style>
